import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PublishedWithChangesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"published_with_changes"}/>
}
